const IssuedHealthClasses = () => {
    let options = [
        { label: "Preferred Plus", value: "Preferred Plus" },
        { label: "Preferred", value: "Preferred" },
        { label: "Standard Plus", value: "Standard Plus" },
        { label: "Standard", value: "Standard" },
        { label: "Preferred Tobacco", value: "Preferred Tobacco" },
        { label: "Standard Plus Tobacco", value: "Standard Plus Tobacco" },
        { label: "Standard Tobacco", value: "Standard Tobacco" },
        { label: "Super Preferred", value: "Super Preferred" },
        { label: "Rated", value: "Rated" },
    ]
    return options;
}

const PaymentOptions = () => {
    let paymentFrequencyOptions = [
        { label: "Annually", value: "A" },
        { label: "Semi-Annually", value: "SA" },
        { label: "Quaterly", value: "Q" },
        { label: "Monthly", value: "M" },
        { label: "Single", value: "S" },
    ];
    return paymentFrequencyOptions;
}

const InForceLedgerOptions = () =>{
    return(
        [
            { label: "No, I don’t have any policy details", value: "inforceLedgerNeeded" },
            { label: "No, but I have an In-Force Ledger Request signed by the policy owner", value: "inforceLedgerRequest" },
            { label: "Yes, I have the full In-Force ledger", value: "hasInforceLedger" },
        ]
    )
}

export { IssuedHealthClasses, PaymentOptions, InForceLedgerOptions }


// WEBPACK FOOTER //
// ./src/components/PolicyReview/SelectOptions.js